/**
 * SubscriptionProduct
 * @class
 */

export class SubscriptionProduct {
  private productContainer: HTMLElement;
  private variantDropDown: HTMLSelectElement;
  private frequencyDropDown: HTMLSelectElement;
  private quantityDropDown: HTMLSelectElement;
  private priceText: HTMLSpanElement;
  private summaryText: HTMLSpanElement;

  /**
   *
   * @param container Containing element of product in subscription builder
   */
  constructor(container: HTMLElement) {
    this.productContainer = container;
    this.variantDropDown =
      this.productContainer.querySelector('select[name=id]');
    this.frequencyDropDown = this.productContainer.querySelector(
      'select[name="properties[shipping_interval_frequency]"]'
    );
    this.quantityDropDown = this.productContainer.querySelector(
      'select[name=quantity]'
    );
    this.priceText = this.productContainer.querySelector('span[data-price]');
    this.summaryText = this.productContainer.querySelector('[data-summary]');

    this.variantDropDown.addEventListener('change', (e) => {
      this.onChangeOption();
    });

    this.frequencyDropDown.addEventListener('change', (e) => {
      this.onChangeOption();
    });

    this.quantityDropDown.addEventListener('change', (e) => {
      this.onChangeOption();
    });

    this.updateSummary();
    this.updatePrice();
  }

  /**
   *
   * @returns Summary text for selections
   */
  private buildSummaryText(): string {
    // {quantiy} x {variant}, delivered {frequency}
    return (
      this.quantityDropDown.value +
      ' x ' +
      this.variantDropDown.selectedOptions[0].text +
      ', delivered every ' +
      this.frequencyDropDown.selectedOptions[0].text
    );
  }

  /**
   *
   * @returns Quanity selected
   */
  private getQuantity(): number {
    return Number(this.quantityDropDown.value);
  }

  /**
   *
   * @returns Total Price of selection
   */
  private getPrice(): number {
    const unitPrice = Number(
      this.variantDropDown.selectedOptions[0].dataset.price
    );
    return unitPrice * this.getQuantity();
  }

  /**
   * Updates sumamry text in UI
   */
  private updateSummary() {
    this.summaryText.innerText = this.buildSummaryText();
  }

  /**
   * Updates price in UI
   */
  private updatePrice() {
    this.priceText.innerText =
      this.priceText.dataset.currencySymbol + this.getPrice().toFixed(2);
  }

  /**
   * Orchestrator for when selection is changed.
   */
  private onChangeOption() {
    this.updateSummary();
    this.updatePrice();
  }
}
